import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const categoryIcons: Record<string, string> = {
  "mingxing-heiliao": "ri-spy-line",
  "lianqing-baoguang": "ri-heart-pulse-line",
  "chouwen-jiemi": "ri-alert-line",
  "zongyi-neimu": "ri-tv-line",
  "pianchang-baoliao": "ri-camera-line",
  "siren-shenghuo": "ri-home-smile-line",
};

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10" aria-label="分类导航">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
          <i className="ri-layout-grid-line text-primary-500 mr-2"></i>
          探索分类
        </h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-900 hover:bg-background-800 border border-background-800/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-200">
              <i className={`${cat.icon} text-xl text-primary-400`}></i>
            </div>
            <div className="text-center">
              <span className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors duration-200 block whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-600 mt-0.5 line-clamp-1">{cat.description}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}